<div class="analytics-container">

  <!-- Header -->
  <div class="analytics-header">
    <div class="header-left">
      <h1 class="header-title">
        <mat-icon class="header-icon">analytics</mat-icon>
        Analytics de Conexiones
      </h1>
      <span class="date-range-badge" *ngIf="!loading && dateFrom && dateTo">
        <mat-icon class="badge-icon">date_range</mat-icon>
        {{ dateFrom | date:'dd MMM' }} - {{ dateTo | date:'dd MMM yyyy' }}
      </span>
    </div>
    <span class="live-badge">
      <span class="live-dot"></span>
      En vivo
    </span>
  </div>

  <!-- Filtros -->
  <div class="filters-wrapper">
    <div class="filters-card">
      <!-- Presets -->
      <div class="presets-row">
        <button *ngFor="let p of [
          { key: 'today', label: 'Hoy', icon: 'today' },
          { key: '7d', label: '7 días', icon: 'date_range' },
          { key: '30d', label: '30 días', icon: 'calendar_month' },
          { key: 'month', label: 'Este mes', icon: 'event' }
        ]"
          class="preset-btn" [class.active]="activePreset === p.key"
          (click)="setPreset(p.key)">
          <mat-icon class="preset-icon">{{ p.icon }}</mat-icon>
          {{ p.label }}
        </button>
      </div>

      <!-- Date range + operadores toggle -->
      <div class="filters-controls">
        <div class="date-fields">
          <mat-form-field appearance="outline" class="modern-field date-field">
            <mat-label>Desde</mat-label>
            <input matInput type="date" [(ngModel)]="dateFrom" (change)="onDateChange()">
          </mat-form-field>
          <mat-form-field appearance="outline" class="modern-field date-field">
            <mat-label>Hasta</mat-label>
            <input matInput type="date" [(ngModel)]="dateTo" (change)="onDateChange()">
          </mat-form-field>
        </div>
        <div class="operator-toggle" [class.active]="excludeOperators"
          (click)="excludeOperators = !excludeOperators; onExcludeOperatorsChange()">
          <div class="toggle-track">
            <div class="toggle-thumb"></div>
          </div>
          <span class="toggle-label" [style.color]="excludeOperators ? '#1C593D' : '#6b7280'">
            {{ excludeOperators ? 'Operadores excluidos' : 'Mostrando todos' }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-state">
    <mat-spinner diameter="48"></mat-spinner>
    <span class="loading-text">Cargando analytics...</span>
  </div>

  <!-- Error -->
  <div *ngIf="error && !loading" class="error-state">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <span class="error-text">Error al cargar datos</span>
    <button class="retry-btn" (click)="loadAll()">Reintentar</button>
  </div>

  <!-- Dashboard Content -->
  <div *ngIf="!loading && !error" class="dashboard-grid fade-in">

    <!-- ═══ KPI CARDS ═══ -->
    <div class="kpi-row">
      <div class="kpi-card">
        <div class="kpi-top">
          <div class="kpi-icon-wrapper bg-green-soft">
            <mat-icon class="kpi-icon text-green">people</mat-icon>
          </div>
          <span class="kpi-label">Usuarios únicos</span>
        </div>
        <div class="kpi-value text-green">{{ formatNumber(summary?.uniqueUsers || 0) }}</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-top">
          <div class="kpi-icon-wrapper bg-blue-soft">
            <mat-icon class="kpi-icon text-blue">link</mat-icon>
          </div>
          <span class="kpi-label">Conexiones totales</span>
        </div>
        <div class="kpi-value text-blue">{{ formatNumber(summary?.totalConnections || 0) }}</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-top">
          <div class="kpi-icon-wrapper bg-purple-soft">
            <mat-icon class="kpi-icon text-purple">equalizer</mat-icon>
          </div>
          <span class="kpi-label">Prom. por usuario</span>
        </div>
        <div class="kpi-value text-purple">{{ (summary?.avgConnectionsPerUser || 0).toFixed(1) }}</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-top">
          <div class="kpi-icon-wrapper bg-orange-soft">
            <mat-icon class="kpi-icon text-orange">timer</mat-icon>
          </div>
          <span class="kpi-label">Permanencia prom.</span>
        </div>
        <div class="kpi-value text-orange">{{ formatDuration(summary?.avgSessionDurationMinutes || 0) }}</div>
      </div>

      <div class="kpi-card">
        <div class="kpi-top">
          <div class="kpi-icon-wrapper bg-red-soft">
            <mat-icon class="kpi-icon text-red">whatshot</mat-icon>
          </div>
          <span class="kpi-label">Hora pico (Chile)</span>
        </div>
        <div class="kpi-value text-red">{{ summary?.peakHour ? toChileHour(parsePeakHour(summary!.peakHour)) + 'h' : '--' }}</div>
      </div>
    </div>

    <!-- ═══ ROW: Países + Tendencias ═══ -->
    <div class="two-col-row">

      <!-- Países -->
      <div class="chart-card">
        <div (click)="toggleSection('countries')" class="chart-card-header">
          <div class="section-title">
            <mat-icon class="section-icon">public</mat-icon>
            <span>Distribución por País</span>
            <span class="section-count" *ngIf="byCountry?.countries?.length">{{ byCountry!.countries.length }}</span>
          </div>
          <mat-icon class="xl-hidden toggle-arrow"
            [style.transform]="expandedSections.has('countries') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="chart-card-body" [class.collapsed]="!expandedSections.has('countries')">
          <div class="country-layout">
            <div class="country-chart-wrapper">
              <canvas #countryChart></canvas>
              <div class="chart-center-label" *ngIf="byCountry?.countries?.length">
                <span class="center-value">{{ formatNumber(summary?.uniqueUsers || 0) }}</span>
                <span class="center-label">total</span>
              </div>
            </div>
            <div class="country-list">
              <div *ngFor="let c of byCountry?.countries; let i = index"
                class="country-row" [class.alt]="i % 2 === 0">
                <div class="country-info">
                  <span class="country-flag">{{ getCountryFlag(c.country) }}</span>
                  <span class="country-name">{{ getCountryName(c.country) }}</span>
                </div>
                <div class="country-data">
                  <div class="country-bar-wrapper">
                    <div class="country-bar" [style.width.%]="c.percentage" [style.background]="getBarColor(i)"></div>
                  </div>
                  <span class="country-users">{{ formatNumber(c.uniqueUsers) }}</span>
                  <span class="country-pct">{{ c.percentage.toFixed(1) }}%</span>
                </div>
              </div>
              <div *ngIf="!byCountry?.countries?.length" class="empty-state-inline">
                Sin datos de países
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tendencias -->
      <div class="chart-card">
        <div (click)="toggleSection('trends')" class="chart-card-header">
          <div class="section-title">
            <mat-icon class="section-icon">trending_up</mat-icon>
            <span>Tendencias</span>
          </div>
          <mat-icon class="xl-hidden toggle-arrow"
            [style.transform]="expandedSections.has('trends') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="chart-card-body" [class.collapsed]="!expandedSections.has('trends')">
          <div class="segmented-control">
            <button *ngFor="let g of [
              { key: 'day', label: 'Día' },
              { key: 'week', label: 'Semana' },
              { key: 'month', label: 'Mes' }
            ]"
              class="segment-btn" [class.active]="groupBy === g.key"
              (click)="onGroupByChange($any(g.key))">
              {{ g.label }}
            </button>
          </div>
          <div class="chart-canvas-wrapper" style="height: 260px;">
            <canvas #trendsChart></canvas>
          </div>
          <div *ngIf="!trends?.data?.length" class="empty-state-inline">
            Sin datos de tendencias para este rango
          </div>
        </div>
      </div>
    </div>

    <!-- ═══ ROW: Dispositivos ═══ -->
    <div class="chart-card">
      <div (click)="toggleSection('devices')" class="chart-card-header">
        <div class="section-title">
          <mat-icon class="section-icon">devices</mat-icon>
          <span>Dispositivos</span>
        </div>
        <mat-icon class="xl-hidden toggle-arrow"
          [style.transform]="expandedSections.has('devices') ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>
      <div class="chart-card-body" [class.collapsed]="!expandedSections.has('devices')">
        <div class="devices-grid">
          <!-- Tipo dispositivo -->
          <div class="device-sub-card">
            <div class="device-sub-header">
              <span class="device-sub-title text-green">Tipo</span>
            </div>
            <div class="chart-canvas-wrapper" style="height: 180px;">
              <canvas #deviceTypeChart></canvas>
            </div>
            <div class="device-stats" *ngIf="byDevice?.byDeviceType?.length">
              <div *ngFor="let d of byDevice!.byDeviceType" class="device-stat-row">
                <span class="device-stat-name">{{ d.deviceType }}</span>
                <span class="device-stat-value">{{ formatNumber(d.uniqueUsers) }}</span>
              </div>
            </div>
          </div>
          <!-- Sistema operativo -->
          <div class="device-sub-card">
            <div class="device-sub-header">
              <span class="device-sub-title text-blue">Sistema Operativo</span>
            </div>
            <div class="chart-canvas-wrapper" style="height: 180px;">
              <canvas #osChart></canvas>
            </div>
            <div class="device-stats" *ngIf="byDevice?.byOS?.length">
              <div *ngFor="let d of byDevice!.byOS" class="device-stat-row">
                <span class="device-stat-name">{{ d.os }}</span>
                <span class="device-stat-value">{{ formatNumber(d.uniqueUsers) }}</span>
              </div>
            </div>
          </div>
          <!-- Navegador -->
          <div class="device-sub-card">
            <div class="device-sub-header">
              <span class="device-sub-title text-purple">Navegador</span>
            </div>
            <div class="chart-canvas-wrapper" style="height: 180px;">
              <canvas #browserChart></canvas>
            </div>
            <div class="device-stats" *ngIf="byDevice?.byBrowser?.length">
              <div *ngFor="let d of byDevice!.byBrowser" class="device-stat-row">
                <span class="device-stat-name">{{ d.browser }}</span>
                <span class="device-stat-value">{{ formatNumber(d.uniqueUsers) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══ ROW: Horas Pico + Permanencia ═══ -->
    <div class="two-col-row">

      <!-- Horas Pico -->
      <div class="chart-card">
        <div (click)="toggleSection('peakHours')" class="chart-card-header">
          <div class="section-title">
            <mat-icon class="section-icon">schedule</mat-icon>
            <span>Horas Pico</span>
          </div>
          <mat-icon class="xl-hidden toggle-arrow"
            [style.transform]="expandedSections.has('peakHours') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="chart-card-body" [class.collapsed]="!expandedSections.has('peakHours')">
          <div *ngIf="peakHours?.peakHour" class="peak-summary">
            <div class="peak-badge">
              <mat-icon class="peak-badge-icon">local_fire_department</mat-icon>
              <span>{{ toChileHour(peakHours!.peakHour.hour) }} hrs</span>
            </div>
            <span class="peak-detail">
              {{ formatNumber(peakHours!.peakHour.connections) }} conexiones &middot;
              {{ formatNumber(peakHours!.peakHour.uniqueUsers) }} usuarios
            </span>
          </div>
          <div class="chart-canvas-wrapper" style="height: 240px;">
            <canvas #peakHoursChart></canvas>
          </div>
          <div class="chart-footnote">Horas en zona horaria Chile (UTC-3)</div>
        </div>
      </div>

      <!-- Permanencia -->
      <div class="chart-card">
        <div (click)="toggleSection('session')" class="chart-card-header">
          <div class="section-title">
            <mat-icon class="section-icon">hourglass_bottom</mat-icon>
            <span>Permanencia</span>
          </div>
          <mat-icon class="xl-hidden toggle-arrow"
            [style.transform]="expandedSections.has('session') ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
        <div class="chart-card-body" [class.collapsed]="!expandedSections.has('session')">
          <!-- Avg / Median badges -->
          <div class="session-badges">
            <div class="session-badge green">
              <mat-icon class="session-badge-icon">speed</mat-icon>
              <span>Promedio: <strong>{{ formatDuration(sessionDuration?.avgDurationMinutes || 0) }}</strong></span>
            </div>
            <div class="session-badge blue">
              <mat-icon class="session-badge-icon">balance</mat-icon>
              <span>Mediana: <strong>{{ formatDuration(sessionDuration?.medianDurationMinutes || 0) }}</strong></span>
            </div>
          </div>
          <!-- Chart -->
          <div class="chart-canvas-wrapper" style="height: 200px;">
            <canvas #sessionChart></canvas>
          </div>
          <!-- Top 10 tabla -->
          <div *ngIf="sessionDuration?.topByDuration?.length" class="top-section">
            <div class="top-section-title">
              <mat-icon class="top-section-icon">emoji_events</mat-icon>
              Top 10 Mayor Permanencia
            </div>
            <div class="top-table-wrapper">
              <table class="top-table">
                <thead>
                  <tr>
                    <th class="th-rank">#</th>
                    <th class="th-user">Usuario</th>
                    <th class="th-right">Duración</th>
                    <th class="th-right">Conexiones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of sessionDuration!.topByDuration; let i = index"
                    class="top-row">
                    <td class="td-rank">
                      <span class="rank-badge" [class.gold]="i === 0" [class.silver]="i === 1" [class.bronze]="i === 2">
                        {{ i + 1 }}
                      </span>
                    </td>
                    <td class="td-user">
                      <div class="user-avatar" [style.background]="getAvatarColor(i)">
                        {{ getInitials(user.nombre) }}
                      </div>
                      <div class="user-info">
                        <span class="user-name">{{ user.nombre }}</span>
                        <span class="user-email">{{ user.email }}</span>
                      </div>
                    </td>
                    <td class="td-right">
                      <span class="duration-value">{{ formatDuration(user.durationMinutes) }}</span>
                    </td>
                    <td class="td-right">
                      <span class="connections-badge">{{ user.connectionCount }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
